<template>
  <v-container>
    <div class="page">
      <div class="title">Demo data files for the following models:</div>
      <div v-for="(item, index) in data" :key="index">
        <div class="section-second-title">{{ item.title }}</div>
        <v-divider class="line"></v-divider>
        <div v-for="(sub, index) in item.subItems" :key="index">
          <div class="item-context">
            <div class="item-word">
              {{sub.subTitle}}: {{sub.description}}
            </div>
            <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="download_pdf(sub.router)">Download</v-btn>
          </div>
          <v-divider class="line"></v-divider>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
data() {
  return {
    data: [{
      title: 'All modules',
      subItems: [{
        subTitle: 'All modules',
        description: 'all demo data',
        router: 'All',
      }]
    },{
      title: 'E-STAT',
      subItems: [{
        subTitle: 'StatTidy',
        description: 'tidying the data',
        router: 'StatTidy',
      },{
        subTitle: 'StatDesc',
        description: 'describe the data',
        router: 'StatDesc',
      },{
        subTitle: 'StatCros',
        description: 'analyze the cross-sectional data',
        router: 'StatCros',
      },{
        subTitle: 'StatMO',
        description: 'analyze the data of multi-omics',
        router: 'StatMO',
      },{
        subTitle: 'StatPanel',
        description: 'analyze the data of panel study',
        router: 'StatPanel',
      },{
        subTitle: 'StatSurv',
        description: 'analyze the censored data',
        router: 'StatSurv',
      },{
        subTitle: 'StatMedt',
        description: 'screening the mediation pathway',
        router: 'StatMedt',
      },{
        subTitle: 'StatMix',
        description: 'analyzing the effect of mixture exposure',
        router: 'StatMix',
      },{
        subTitle: 'StatHEP',
        description: 'predict human chemical exposure',
        router: 'StatHEP',
      },{
        subTitle: 'StatIP',
        description: 'explore the statistical explanation',
        router: 'StatIP',
      }]
    },{
      title: 'E-DB',
      subItems: [{
        subTitle: 'EDb',
        description: 'support the ExposomeX platform',
        router: 'EDb',
      }]
    },{
      title: 'E-MS',
      subItems: [{
        subTitle: 'EMS',
        description: 'analyze the non-targeted from HRMS',
        router: 'EMS',
      }]
    },{
      title: 'E-META',
      subItems: [{
        subTitle: 'EMeta',
        description: 'provide the summary of the previous publications',
        router: 'EMeta',
      }]
    },{
      title: 'E-BIO',
      subItems: [{
        subTitle: 'EBio',
        description: 'explore the biological explanation',
        router: 'EBio',
      }]
    },{
      title: 'E-VIZ',
      subItems: [{
        subTitle: 'EViz',
        description: 'visualize the data',
        router: 'EViz',
    }]
  }]
  }
},
methods: {
  async download_pdf(name){
    let a = document.createElement('a')
    a.href = 'http://www.exposomex.cn/exposome/Downloadpdf/' + name
    a.target='_blank'
    a.click()
  },
},
};
</script>
<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
.title {
  font-weight: 600;
  font-size: $webpage-large-font-size;
  margin: 1em 0 0.6em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.section-second-title {
  font-weight: bold;
  margin: 0.6em 0 0.2em;
}
.line {
  width: 90%;
}
.item-word {
  min-width: 800px;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-word {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
  }
  .item-word {
    min-width: 0;
  }
}
</style>
